// import store from "../../stores";
import type { DirectiveBinding } from 'vue';
import { useUserStore } from '~/stores/user';

export const permissionDirective = {
    mounted(el: HTMLElement, { value }: DirectiveBinding) {
        const uerStore = useUserStore();
        const store = null;
        try {
            let show = false;
            const permissions = uerStore.permissions || [];
            if (permissions.includes('*:*:*')) {
                show = true;
            }
            if (value === undefined) {
                return el.style.display = 'unset';
            }
            if (Array.isArray(value)) {
                for (const code of value) {
                    if (permissions.includes(code)) {
                        show = true;
                        break;
                    }
                }
            } else {
                if (permissions.includes(value)) show = true;
            }
            if (!show) el.style.display = 'none';
        } catch (e) {
            el.style.display = 'none';
        }
    },
}
